(function (Drupal, once) {

  Drupal.behaviors.bendrejatParallax = {

    attach(context) {

      once(
        'bendrejat-parallax',
        '.views-works-masonry .views-field-works-svg',
        context
      ).forEach((svg) => {

        const speed = 0.25;
        const initialScrollY = window.scrollY;

        let ticking = false;

        const updateParallax = () => {

          const scrollDistance = window.scrollY - initialScrollY;
          const offset = scrollDistance * speed;

          svg.style.transform = `translate3d(0, ${offset}px, 0)`;

          ticking = false;
        };

        const onScroll = () => {

          if (!ticking) {
            window.requestAnimationFrame(updateParallax);
            ticking = true;
          }

        };

        window.addEventListener('scroll', onScroll, {
          passive: true
        });

      });

    }

  };

})(Drupal, once);